import React from 'react';
import { useParams } from 'react-router-dom';

import { SchedulerPreview } from 'components/Scheduler';

import './public-scheduler.scss';

const PublicSchedulerPage = () => {
  const { configId } = useParams();

  return (
    <div className="public-scheduler-page">
      <SchedulerPreview
        configurationId={configId}
      />
    </div>
  );
};

export default PublicSchedulerPage;
